import React from 'react';
import { Form, Container } from 'react-bootstrap';

const SurveyFinalMessage = ({values, handleChange, errors}) => {
  return (
    <Container>
      <Form.Group className="mt-3">
        <Form.Control
          as="textarea"
          rows={3}
          name="finalMessage"
          placeholder="Mensaje final de la encuesta"
          onChange={handleChange}
          value={values.finalMessage}
          isInvalid={!!errors.finalMessage}
        />
        <Form.Control.Feedback type="invalid">
          {errors.finalMessage}
        </Form.Control.Feedback>
      </Form.Group>
    </Container>
  )
}

export default SurveyFinalMessage